<template>
  <el-dialog v-if="showType===SHOW_TYPE.DEFAULT" title="索要发票" :visible.sync="$store.state.Invoice.AskForAnInvoiceShow" width="820px" :before-close="cancel" :destroy-on-close="false" :close-on-click-modal="false">
    <el-descriptions :column="1" border>
      <el-descriptions-item label="订单号">{{$store.state.Invoice.selectedOrderId}}</el-descriptions-item>
      <el-descriptions-item label="选择发票信息">
        <el-select v-model="selectedInvoiceId">
        <el-option :label="item.fpType==1?item.fpCommonCompanyName:item.fpType==2?item.fpCompanyName:''" :value="item.id" v-for="item in invoiceList" :key="item.id" />
      </el-select>
        <div style="display: inline-block;margin-left: 10px">
          <el-button @click="addInvoiceRun">新增</el-button>
          <el-button v-show="selectedInvoiceId" @click="updateInvoiceInfo">修改</el-button>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="选择发票地址">
        <el-select v-model="selectedAddressId">
        <el-option :label="item.lxr" :value="item.id" v-for="item in getAddressList" :key="item.id" />
      </el-select>
        <div style="display: inline-block;margin-left: 10px">
          <el-button @click="addAddressRun">新增</el-button>
          <el-button v-show="selectedAddressId" @click="updateAddressInfo">修改</el-button>
        </div>
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions title="开票地址" :column="3" border v-if="selectedInvoiceId" style="margin: 10px 0">
      <!--      label-class-name="my-label" content-class-name="my-content"-->
      <el-descriptions-item label="公司名称" >{{selectedInvoiceListContext.fpType==1?selectedInvoiceListContext.fpCommonCompanyName:selectedInvoiceListContext.fpType==2?selectedInvoiceListContext.fpCompanyName:''}}</el-descriptions-item>
      <el-descriptions-item label="公司账号" v-if="selectedInvoiceListContext.fpBankCode">{{ selectedInvoiceListContext.fpBankCode }}</el-descriptions-item>
      <el-descriptions-item label="公司开户行" v-if="selectedInvoiceListContext.fpBankType">{{ selectedInvoiceListContext.fpBankType }}</el-descriptions-item>
      <el-descriptions-item label="纳税人识别号">{{selectedInvoiceListContext.fpIdCode}}</el-descriptions-item>
      <el-descriptions-item label="联系地址" v-if="selectedInvoiceListContext.fpAddress">{{ selectedInvoiceListContext.fpAddress }}</el-descriptions-item>
      <el-descriptions-item label="公司电话" v-if="selectedInvoiceListContext.fpPhone">{{selectedInvoiceListContext.fpPhone}}</el-descriptions-item>
      <el-descriptions-item label="发票类型">{{selectedInvoiceListContext.fpType==1?'普通发票':selectedInvoiceListContext.fpType==2?'增值税发票':''}} </el-descriptions-item>
    </el-descriptions>
    <el-descriptions title="发票地址" :column="3" border v-if="selectedAddressId">
<!--      label-class-name="my-label" content-class-name="my-content"-->
      <el-descriptions-item label="收货人" >{{ selectedAddressContext.lxr }}</el-descriptions-item>
      <el-descriptions-item label="手机号">{{ selectedAddressContext.telephone }}</el-descriptions-item>
      <el-descriptions-item label="座机号" v-if="selectedAddressContext.phone">{{selectedAddressContext.phone}}</el-descriptions-item>
      <el-descriptions-item label="邮箱" v-if="selectedAddressContext.email">{{selectedAddressContext.email}}</el-descriptions-item>
      <el-descriptions-item label="地址" >{{ selectedAddressContext.provinceName }} {{ selectedAddressContext.cityName }} {{ selectedAddressContext.countyName }} {{ selectedAddressContext.address }}</el-descriptions-item>
    </el-descriptions>
    <div slot="footer">
      <el-button @click="askForInvoice">提交</el-button>
    </div>
  </el-dialog>
  <EditInvoice v-else-if="showType===SHOW_TYPE.INVOICE" @cancel="cancelInvoice" :id="invoiceId" @save="saveInvoice"/>
</template>

<script>
import {mapMutations, mapGetters} from 'vuex';
import {getUserInvoice, applyForInvoice} from '@/assets/request/InvoiceRequest';
import EditInvoice from "./EditInvoice";
import {Message} from "element-ui";
export default {
  name: "AskForAnInvoice",
  components:{EditInvoice},
  computed:{
    ...mapGetters(['getAddressList']),
    selectedAddressContext(){
      const current = this.getAddressList.find(i=>this.selectedAddressId===i.id);
      const a = {
        lxr:null,
        phone:null,
        telephone:null,
        email:null,
        provinceName:null,
        cityName:null,
        countyName:null,
        address:null,
      }
      return current?current:a;
    },
    selectedInvoiceListContext(){
      const current = this.invoiceList.find(i=>i.id===this.selectedInvoiceId);
      const a = {
        fpCompanyName:null,
        fpCommonCompanyName:null,
        fpIdCode:null,
        tax_point:null,
        fpPhone:null,
        fpType:null,
        fpBankCode:null,
        fpBankType:null,
      };
      return current?current:a;
    },
  },
  methods:{
    ...mapMutations(['toggleAskForInvoiceShow','updateSelectedOrderId','deductTab','editGlobalEditAddressShow']),

    askForInvoice(){
      if(!this.selectedInvoiceId) return alert('请选择发票信息');
      if(!this.selectedAddressId) return alert('请选择发票地址');
      applyForInvoice(this.$store.state.Invoice.selectedOrderId,this.selectedInvoiceId,this.selectedAddressId).then(r=>{
        if(r.status!==200) return alert(r.statusText);
        if(r.data.code!=1) return alert(r.data.msg);
        Message.success(r.data.msg);
        const frame = document.getElementsByTagName('iframe');
        const index = Array.from(frame).filter(i=>i.name='factoryOrder' || i.name==='factoryOrderDetail');
        if(index.length) index.forEach(i=> {
          i.src = i.src;
        });
        this.$store.state.Invoice.isClose && this.deductTab(this.$store.state.activeTab);
        this.cancel();
      });
    },
    cancel(){
      this.selectedAddressId = null;
      this.selectedInvoiceId = null;
      this.toggleAskForInvoiceShow(false);
      this.updateSelectedOrderId(null);
    },
    addAddressRun(){
      this.editGlobalEditAddressShow({show:true});
    },
    addInvoiceRun(){
      this.invoiceId=null;
      this.showType=this.SHOW_TYPE.INVOICE;
    },
    cancelInvoice(){
      this.showType=this.SHOW_TYPE.DEFAULT;
    },
    updateInvoiceInfo(){
      this.invoiceId = Number(this.selectedInvoiceId);
      this.showType=this.SHOW_TYPE.INVOICE;
    },
    updateAddressInfo(){
      this.editGlobalEditAddressShow({show:true,id:Number(this.selectedAddressId)});
    },
    getInvoice(){
      getUserInvoice().then(r=>{
        this.invoiceList = r.data.data;
      });
    },
    saveInvoice(e){
      this.cancelDefault();
      this.getInvoice();
    },
    cancelDefault(){
      this.showType=this.SHOW_TYPE.DEFAULT;
    },
  },
  data:()=>({
    SHOW_TYPE:{
      DEFAULT:1,
      INVOICE:2,
      ADDRESS:3,
    },
    showType:1,
    invoiceList:[],
    selectedAddressId:null,
    selectedInvoiceId:null,
    invoiceId:0,
  }),
  created() {
    this.getInvoice();
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-select .el-input__inner:focus{
  border-color: var(--JN_mainColor);
}
::v-deep .el-range-editor.is-active, .el-range-editor.is-active:hover, .el-select .el-input.is-focus .el-input__inner{
  border-color: var(--JN_mainColor);
}
.el-range-editor.is-active, .el-range-editor.is-active:hover, .el-select .el-input.is-focus .el-input__inner{
  border-color: var(--JN_mainColor);
}
.el-select-dropdown__item.selected{
  color: var(--JN_mainColor);
}

::v-deep .el-dialog__header{
  background-color: var(--JN_mainColor);
  color: white;
  *{
    color: white;
  }
}
/*::v-deep .el-descriptions .is-bordered .el-descriptions-item__cell{
  border-color: #cccccc;
}*/
/*::v-deep table{
  border: 1px solid #cccccc;
  border-radius: 10px;
  //border-collapse: separate;
}*/
/*::v-deep .my-label {
  background: #E1F3D8;

}
::v-deep .my-content {
  background: #FDE2E2;
}*/
.el-button{
  border-color: var(--JN_mainColor);
  background-color: white;
  color: var(--JN_mainColor);
  &:hover{
    background-color: var(--JN_mainColor);
    color: white;
  }
}
</style>